module.exports = __webpack_public_path__ + "img/ar-sm-d.b4d7b6dd.svg";